import React from 'react';
import LoginModal from './ui-elements/LoginModal';
import './ui-elements/LoginModal.scss';

const Admin = () => {
    return (
        <div className="sski-admin-dashboard">
            <LoginModal />
        </div>
    );
};

export default Admin;
